import '../css/faq.css';

export default () => {
    return (
        <div className="page-content">
            <h1 className="tab-header">Frequently Asked Questions</h1>

            <div className="question">What is your billing policy?</div>
            <div>
                We don't participate with any particular insurance plans, but rather have one fee for all patients. However, if you have insurance we will 
                gladly process their claim for any dental work. Generally, we prefer cash, check, Mastercard, or Visa as methods of payment at time of service. 
                We also offer payment plans to our regular, trusted patients.
            </div>
            <div className="question">What's the difference between a cap and a crown?</div>
            <div>Nothing — they mean the same thing.
                <br/><br/>
                A crown is recommended when more than half of the tooth structure is either gone or filled. Other reasons for getting a crown include having a root canal or symptoms of Cracked Tooth Syndrome (i.e. cold sensitivity and sharp pain upon biting down).
            </div>
            <div className="question">Is bleaching safe?</div>
            <div>
                Yes ... if done as recommended.
                <br/><br/>
                Bleaching can burn tissue if not applied <em>exclusively</em> to the enamel.
            </div>
            <div className="question">Why do I need x-rays?</div>
            <div>Sometimes we can't detect problems within the teeth/bones themselves just by looking at their outsides — x-rays provide us with that extra internal perspective.
                Children and the elderly actually develop decay and problems more readily due to changes in diet, hormones, and saliva chemistry. X-rays also allow us to assess the soundness of existing restorations.
            </div>
            <div className="question">Will the shots hurt?</div>
            <div>
                We're told consistently that we give a 'gentle' shot; we also use a topical anesthesia before the injection to minimize the pain.
            </div>
		</div>
    );
};